import { render, staticRenderFns } from "./manageAccounts.vue?vue&type=template&id=0884e869&scoped=true"
import script from "./manageAccounts.vue?vue&type=script&lang=js"
export * from "./manageAccounts.vue?vue&type=script&lang=js"
import style0 from "./manageAccounts.vue?vue&type=style&index=0&id=0884e869&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0884e869",
  null
  
)

export default component.exports